var render = function render(_c,_vm){return _c('span',{domProps:{"innerHTML":_vm._s(_vm.parent.$tc('miniCart.cartItemCount', _vm.props.count))}})
}
var staticRenderFns = []

export { render, staticRenderFns }